module.exports = __webpack_public_path__ + "static/gnome-1-81299a6b8d7698b6c99a179db18740c2.png";